import axios from 'axios';

export const axiosInstance = axios.create({
    baseURL: `https://gaogaolatlat.shop`
    // baseURL: `http://localhost:5202`
});
